import moment from 'moment';
import { environment } from 'environments';

(() => {
  TokboxController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "ngDialog", "Notifications", "Orders", "Logger", "Constants", "Utils", "VideoService", "localStorageService", "Auth"];

  function TokboxController($rootScope, $scope, $timeout, $interval, toastr, ngDialog, Notifications, Orders, Logger, Constants, Utils, VideoService, localStorageService, Auth) {
    'ngInject'; // DEFAULT (can be overrided by Content table / localStorageService)
    // "1280x720", "640x480", "320x240"

    let resolutionWidth = "640";
    let resolutionHeight = "480"; // 30, 15, 7, 1

    let frameRate = 15;
    let tokbox_parameters = localStorageService.get('tokbox_parameters');
    let testNetwork = false;
    let restrictFrameRate = false;
    let getShowStats = false;

    if (tokbox_parameters) {
      resolutionWidth = tokbox_parameters.resolutionWidth;
      resolutionHeight = tokbox_parameters.resolutionHeight;
      frameRate = tokbox_parameters.frameRate;
      testNetwork = tokbox_parameters.testNetwork;
      restrictFrameRate = tokbox_parameters.restrictFrameRate;
      getShowStats = tokbox_parameters.getShowStats;
    }

    let resolution = resolutionWidth + "x" + resolutionHeight;
    let subscriber;
    let statsTimer;
    let numStatsCalls = 0;
    let prevPublisherStatsArray;
    let prevSubscriberStats; //let session;

    let publisher;
    let disconnectTimer;
    let isStreamConnected = false; //let countVideoCalls = 0;

    Object.assign(this, {
      initialized: false,
      fullscreen: false,
      audioEnabled: true,
      publisherEnabled: true,
      //task: this.visit.getTask(Constants.VisitTasks.SmartLiveVideo),
      polls: {},
      currentUser: Auth.profile,
      patient: $scope.ngDialogData.patient,
      visit: $scope.ngDialogData.visit
    });
    this.task = this.visit.getTask(Constants.VisitTasks.SmartLiveVideo), this.startedCall = false;
    this.hangUpRedoButtonReady = false;
    $timeout(() => {
      this.hangUpRedoButtonReady = true;
      console.log("hangUpRedoButtonReady");
    }, 5000); // $scope.$on('openHangupModal', () => {
    //   this.openHangupModal();
    // });

    $scope.$on('videocall:clear-queue-entry', () => {
      this.visit.queue_entry = null;
    });
    $scope.$on('videocall:cancel-stats-timer', () => {
      $interval.cancel(statsTimer);
      statsTimer = null;
    });
    $scope.$on('tokbox:task-updated', (event, args) => {
      this.initialized = false;
      this.call = null;
      this.audioEnabled = true;
      this.task.status = args.taskStatus;
      publisher = null;
      this.fullscreen = false;
    });
    $scope.$on('checkResetVideoCalls', () => {
      this.checkResetVideoCalls();
    }); // $scope.$on('resetVideoCall', (event, args) => {
    //   this.resetVideoCall(args.videocall);
    // });
    // This did not work for ngDialog
    // This just works for basic modals
    // $('.ngdialog-content').draggable();
    // We do this to make the modal "movable or draggable"

    $scope.$on('ngDialog.opened', function (e, $dialog) {
      $(".ngdialog-theme-default.tokbox-modal").children(".ngdialog-content").draggable({
        //handle: ".tokbox-header"
        handle: ".tokbox-handler" // drag: function( event, ui ) {
        //   console.log("drag event triggering");
        //   console.log(ui);
        //   ui.position.left = Math.min( 100, ui.position.left );
        // }

      });
    });

    this.calculateVideoScore = (baseBitrate, width, height) => {
      const MIN_VIDEO_BITRATE = 30000;

      const targetBitrateForPixelCount = pixelCount => {
        // power function maps resolution to target bitrate, based on rumor config
        // values, with r^2 = 0.98. We're ignoring frame rate, assume 30.
        const y = 2.069924867 * Math.log10(pixelCount) ** 0.6250223771;
        return 10 ** y;
      };

      const pixelCount = width * height;
      const targetBitrate = targetBitrateForPixelCount(pixelCount);

      if (baseBitrate < MIN_VIDEO_BITRATE) {
        return 1;
      }

      const bitrate = Math.min(baseBitrate, targetBitrate);
      let score = Math.log(bitrate / MIN_VIDEO_BITRATE) / Math.log(targetBitrate / MIN_VIDEO_BITRATE) * 4 + 1;
      score = Math.min(score, 4.5);
      return score;
    };

    this.rateMosScore = mos => {
      if (mos >= 3.8) {
        return 'Excellent';
      }

      if (mos >= 3.1) {
        return 'Good';
      }

      if (mos >= 2.4) {
        return 'Fair';
      }

      if (mos >= 1.7) {
        return 'Poor';
      }

      return 'Bad';
    };

    this.createCall = () => {
      if (this.startedCall) return;
      this.startedCall = true; // First we validate if the visit is still on the queue

      Orders.getOne(this.visit.id).then(({
        data
      }) => {
        //this.visit = data;
        Object.assign(this.visit, data);

        if (!data.queue_entry) {
          // Visit is not on the queue anymore
          // We hide the "Start Video" button
          this.visit.queue_entry = null;
          $rootScope.queueEntryExists = false;
          toastr.error('Patient is not on the video queue anymore.');
          return;
        } else {
          $rootScope.queueEntryExists = true; // Visit still on the queue

          this.callLoading = true;
          VideoService.createCall(this.visit.queue_entry.id).then(({
            data
          }) => {
            this.call = data;
            this.initialize(data);
          }).catch(err => {
            // Protect from two doctors calling user
            const message = err.status === 403 ? Notifications.orders.locked : 'Failed to initiate the call.';
            Utils.createErrorToast(err, message);
            this.callLoading = false;
          });
        }
      }).catch(error => {}).finally(() => {
        $timeout(() => {
          this.startedCall = false;
        }, 5000);
      });
    };

    this.createCall();

    this.initialize = () => {
      $rootScope.videoSession = OT.initSession(environment.constants.TOKBOX_API_KEY, this.call.session_id);
      $rootScope.videoSession.connect(this.call.session_token, err => {
        if (err) {
          // THIS FIXES THE BUG WHEN
          // THERE IS BAD INTERNET CONNECTION
          // VIDEOCALL IS CREATED ON DB
          // BUT VIDEO CONNECTION FAILS TO BE CREATED
          this.resetVideoCall(this.call);
          toastr.error('Failed to connect to Tokbox.');
          return;
        }

        $scope.$apply(() => {
          this.initialized = true;
          this.callLoading = false;
          this.waitingMessage = 'Waiting for patient to connect...'; // $(".ngdialog-content").css("resize", "both");
          // $(".ngdialog-content").css("height", "424px");
          // $(".tokbox-body").css("height", "354px");
          // $(".ngdialog-content").resizable({
          //   resize: function( event, ui ) {
          //     ui.size.width = Math.round((ui.size.height * 290) / 424);
          //     var headerHeight = $(".tokbox-header").css("height");
          //     headerHeight = headerHeight.replace("px","");
          //     var bodyHeight = ui.size.height - parseInt(headerHeight) - 20;
          //     $(".tokbox-body").css("height", bodyHeight);
          //   }
          // });
        });
        publisher = OT.initPublisher('publisher', {
          insertMode: 'append',
          width: '100px',
          height: '100px',
          showControls: false,
          // audioBitrate: 64000,
          // disableAudioProcessing: true,
          resolution: resolution,
          frameRate: frameRate
        });
        $timeout(() => {
          $("#publisher").draggable({
            handle: ".OT_publisher"
          });
        });
        $rootScope.videoSession.on('streamDestroyed', event => {
          Logger.debug('Stream Destroyed', event);
          this.waitingMessage = 'Patient may be trying to reconnect.';
          isStreamConnected = false; // isStreamConnected can be reset to true before
          // the callback runs in the timeout below.
          // This timeout gives the patient the opportunity to reconnect if their
          // publisher stopped publishing and is trying to restart (andoid chrome 54)

          $timeout(() => {
            if (!isStreamConnected) {
              VideoService.audit('QU_PATIENT_STREAM_DESTROYED', this.patient.id, this.task.id);

              if (event.reason === 'networkDisconnected') {
                this.startDisconnectTimer();
              } else if (event.reason === 'clientDisconnected') {
                this.waitingMessage = 'Patient has hung up. Please assess the video.';
                $timeout(() => this.openHangupModal(), 1000);
              }
            }
          }, 1500);
        });
        $rootScope.videoSession.on('streamCreated', event => {
          Logger.debug('Stream created ', event);
          isStreamConnected = true;
          VideoService.audit('QU_PATIENT_STREAM_CREATED', this.patient.id, this.task.id);
          this.waitingMessage = null;
          subscriber = $rootScope.videoSession.subscribe(event.stream, 'subscriber', {
            insertMode: 'append',
            width: '100%',
            height: '100%',
            showControls: false,
            testNetwork: testNetwork // resolution: resolution,
            // frameRate: frameRate,
            // preferredResolution: { width: resolutionWidth, height: resolutionHeight },
            // preferredFrameRate: frameRate,

          });
          subscriber.restrictFrameRate(restrictFrameRate);

          if (getShowStats) {
            statsTimer = $interval(() => {
              // numStatsCalls++;
              // if (numStatsCalls > 20) {
              //   $rootScope.$broadcast('videocall:publisher-update', '');
              //   $rootScope.$broadcast('videocall:subscriber-update', '');
              //   $interval.cancel(statsTimer);
              //   statsTimer = null;
              //   return;
              // }
              publisher.getStats((error, publisherStatsArray) => {
                if (error) {
                  console.error('Error getting publisher stats: ', error.message);
                  return;
                } // console.log("Data Transmission Stats (Publisher)");
                // console.log("Video resolution:", publisher.videoWidth(), "X", publisher.videoHeight());


                var publisherQualityStats = '<strong>Video resolution: </strong>' + publisher.videoWidth() + 'X' + publisher.videoHeight() + '<br>';

                if (prevPublisherStatsArray) {
                  publisherStatsArray.forEach((publisherStats, index) => {
                    var videoPacketLossRatio = publisherStats.stats.video.packetsLost / (publisherStats.stats.video.packetsLost + publisherStats.stats.video.packetsSent); // console.log('Video packet loss ratio:', videoPacketLossRatio);

                    publisherQualityStats += '<strong>Video packet loss ratio: </strong>' + videoPacketLossRatio + '<br>';
                    var videoBitRate = 8 * (publisherStats.stats.video.bytesSent - prevPublisherStatsArray[index].stats.video.bytesSent); // console.log('Video bit rate:', videoBitRate, 'bps');

                    publisherQualityStats += '<strong>Video bit rate: </strong>' + videoBitRate + ' bps' + '<br>'; // console.log('Video frame rate:', publisherStats.stats.video.frameRate);

                    publisherQualityStats += '<strong>Video frame rate: </strong>' + publisherStats.stats.video.frameRate + '<br>';
                    var mos = this.calculateVideoScore(videoBitRate, parseInt(publisher.videoWidth()), parseInt(publisher.videoHeight())); // console.log('Video quality:', mos, '('+this.rateMosScore(mos).toUpperCase()+')');

                    publisherQualityStats += '<strong>Video quality: </strong>' + mos + ' (' + this.rateMosScore(mos).toUpperCase() + ')' + '<br>';
                    var audioPacketLossRatio = publisherStats.stats.audio.packetsLost / (publisherStats.stats.audio.packetsLost + publisherStats.stats.audio.packetsSent); // console.log('Audio packet loss ratio:', audioPacketLossRatio);

                    publisherQualityStats += '<strong>Audio packet loss ratio: </strong>' + audioPacketLossRatio + '<br>';
                    var audioBitRate = 8 * (publisherStats.stats.audio.bytesSent - prevPublisherStatsArray[index].stats.audio.bytesSent); // console.log('Audio bit rate:', audioBitRate, 'bps');

                    publisherQualityStats += '<strong>Audio bit rate: </strong>' + audioBitRate + ' bps' + '<br>';
                  });
                } // console.log(publisherQualityStats);


                $rootScope.$broadcast('videocall:publisher-update', publisherQualityStats);
                prevPublisherStatsArray = publisherStatsArray;
              });
              subscriber.getStats((error, subscriberStats) => {
                if (error) {
                  console.error('Error getting subscriber stats: ', error.message);
                  return;
                } // console.log("Data Reception Stats (Subscriber)");
                // console.log("Video resolution:", subscriber.videoWidth(), "X", subscriber.videoHeight());


                var subscriberQualityStats = '<strong>Video resolution: </strong>' + subscriber.videoWidth() + 'X' + subscriber.videoHeight() + '<br>';

                if (prevSubscriberStats) {
                  var videoPacketLossRatio = subscriberStats.video.packetsLost / (subscriberStats.video.packetsLost + subscriberStats.video.packetsReceived); // console.log('Video packet loss ratio:', videoPacketLossRatio);

                  subscriberQualityStats += '<strong>Video packet loss ratio: </strong>' + videoPacketLossRatio + '<br>';
                  var videoBitRate = 8 * (subscriberStats.video.bytesReceived - prevSubscriberStats.video.bytesReceived); // console.log('Video bit rate:', videoBitRate, 'bps');

                  subscriberQualityStats += '<strong>Video bit rate: </strong>' + videoBitRate + ' bps' + '<br>'; // console.log('Video frame rate:', subscriberStats.video.frameRate);

                  subscriberQualityStats += '<strong>Video frame rate: </strong>' + subscriberStats.video.frameRate + '<br>';
                  var mos = this.calculateVideoScore(videoBitRate, parseInt(subscriber.videoWidth()), parseInt(subscriber.videoHeight())); // console.log('Video quality:', mos, '('+this.rateMosScore(mos).toUpperCase()+')');

                  subscriberQualityStats += '<strong>Video quality: </strong>' + mos + ' (' + this.rateMosScore(mos).toUpperCase() + ')' + '<br>';
                  var audioPacketLossRatio = subscriberStats.audio.packetsLost / (subscriberStats.audio.packetsLost + subscriberStats.audio.packetsReceived); // console.log('Audio packet loss ratio:', audioPacketLossRatio);

                  subscriberQualityStats += '<strong>Audio packet loss ratio: </strong>' + audioPacketLossRatio + '<br>';
                  var audioBitRate = 8 * (subscriberStats.audio.bytesReceived - prevSubscriberStats.audio.bytesReceived); // console.log('Audio bit rate:', audioBitRate, 'bps');

                  subscriberQualityStats += '<strong>Audio bit rate: </strong>' + audioBitRate + ' bps' + '<br>';
                } // console.log(subscriberQualityStats);


                $rootScope.$broadcast('videocall:subscriber-update', subscriberQualityStats);
                prevSubscriberStats = subscriberStats;
              });
            }, 1000);
          }

          var subscriberElem = document.getElementById("subscriber");
          var numChildren = subscriberElem.childNodes.length; // We "hide" all children of element "subscriber" except the "last child",
          // that holds the current video streaming (camera of patient)
          // This is to avoid "black screens" when "subscriber" has many children

          if (numChildren > 0) {
            for (var i = 0; i < numChildren; i++) {
              if (i < numChildren - 1) {
                subscriberElem.childNodes[i].style.display = 'none';
              }
            }
          }
        });
        OT.on('exception', event => {
          Logger.debug('Shitception: ', event);

          if (event.code === 1553) {
            // 1553 patient disconnected
            this.startDisconnectTimer();
          }
        });
        $rootScope.videoSession.publish(publisher);
      });
    };

    this.showHangupModal = () => {
      if ($rootScope.numActiveCalls === undefined) $rootScope.numActiveCalls = 0;
      if ($rootScope.numActiveCalls > 0) return true;
      return false;
    };

    this.queueEntryExists = () => {
      if ($rootScope.queueEntryExists === undefined) $rootScope.queueEntryExists = false;
      return $rootScope.queueEntryExists;
    };

    this.checkResetVideoCalls = () => {
      Orders.getVideoCalls(this.visit.id).then(data2 => {
        var numActiveCalls = 0;
        var activeVideoCalls = [];
        data2.data.forEach(videocall => {
          if (videocall.ended === null) {
            numActiveCalls++;
            videocall.doctor_id = videocall.doctor.id;
            activeVideoCalls.push(videocall);
          }
        });

        if (numActiveCalls > 0) {
          var videocall = activeVideoCalls[0];
          this.resetVideoCall(videocall);
        }
      }).catch(err => {
        console.log(err);
      });
    };

    this.resetVideoCall = videocall => {
      const {
        Approved,
        Closed,
        Rejected
      } = Constants.VisitStatuses;

      if (!this.call) {
        this.call = videocall;
      } // We put "OTHER" as issues to Redo the call


      var issues = [{
        "code": "OTHER",
        "name": "Other"
      }]; // newStatus === 4

      var newStatus = Closed; // to Redo the call:
      // null out the video call id
      // and update task newStatus to closed

      VideoService.updateCall(this.call.id, 'now', issues).then(() => {
        if (this.visit.queue_entry) {
          VideoService.nullQueueSession(this.visit.queue_entry).finally(() => {
            this.updateTask(newStatus);
          });
        } else {
          this.updateTask(newStatus);
        }
      }).catch(err => {
        Utils.createErrorToast(err, 'Failed to hang up the video call.');
      });
    };

    this.openHangupModal = () => {
      VideoService.openHangupModal(this.task, this.call, this.visit.queue_entry);
    };
    /*
    this.openHangupModal_OLD = () => {
       if (!this.dialog) {
         // This is to stop checking active videocalls temporarilly
        // And hide "Hang-up and Redo Video Call" button
        // While doctor is assessing the videocall
        $rootScope.assessingVideoCall = true;
        $rootScope.numActiveCalls = 0;
         this.dialog = ngDialog.open({
          templateUrl: 'app/components/tokbox/hangup.modal.html',
           closeByEscape: false,
          closeByNavigation: false,
          closeByDocument: false,
           controller($scope, issues) {
            'ngInject';
             $scope.issues = issues;
            $scope.selectedIssues = [];
            $scope.submit = (newStatus) => {
              if (!$scope.selectedIssues.length) {
                $scope.error = 'Please select at least one option';
                return;
              }
               $scope.closeThisDialog({
                newStatus,
                issues: $scope.selectedIssues.map(issue => issue.code),
              });
            };
          },
          resolve: {
            issues: () => VideoService.getIssues().then(({ data }) => data),
          },
          preCloseCallback: ({ newStatus, issues }) => {
            this.dialog = null;
             if (isNaN(newStatus)) {
              return;
            }
             // TO CANCEL THE VIDEO QUALITY STATS TIMER
            $rootScope.$broadcast('videocall:publisher-update', '');
            $rootScope.$broadcast('videocall:subscriber-update', '');
            $interval.cancel(statsTimer);
            statsTimer = null;
             // Possible new statuses:
            // 3: approved, patient passed video consultation
            // 4: rejected, patient needs to redo video
            // 5: closed, patient did not pass video consultation
             VideoService
              .updateCall(this.call.id, 'now', issues)
              .then(() => {
                const { Approved, Closed, Rejected } = Constants.VisitStatuses;
                 if (this.visit.queue_entry) {
                  if (newStatus === Approved || newStatus === Rejected) {  // newStatus === 3 || newStatus === 5
                    // If approved or rejected, remove patient from
                    // the queue and update newStatus appropriately
                    VideoService
                      .removeQueueEntry(this.visit.queue_entry)
                      .finally(() => {
                        this.visit.queue_entry = null;
                        this.updateTask(newStatus);
                        $rootScope.assessingVideoCall = false;
                        $rootScope.$broadcast('videocall:finished');
                      });
                  } else if (newStatus === Closed) {  // newStatus === 4
                    // If closed (to redo the video), null out the video call id
                    // and update task newStatus to closed
                    VideoService
                      .nullQueueSession(this.visit.queue_entry)
                      .finally(() => {
                        this.updateTask(newStatus);
                        $rootScope.assessingVideoCall = false;
                        $rootScope.$broadcast('videocall:finished');
                         // On "redo" we also resize the video modal window to the initial size
                        // $(".ngdialog-content").css("resize", "unset");
                        // $(".ngdialog-content").css("height", "120px");
                        // $(".ngdialog-content").css("width", "290px");
                        // $(".tokbox-body").css("height", "70px");
                      });
                  }
                } else {
                  this.updateTask(newStatus);
                  $rootScope.assessingVideoCall = false;
                  $rootScope.$broadcast('videocall:finished');
                }
              })
              .catch((err) => {
                $rootScope.assessingVideoCall = false;
                $rootScope.$broadcast('videocall:finished');
                Utils.createErrorToast(err, 'Failed to hang up the video call.');
              });
          },
        });
      }
    };
    */


    this.toggleAudio = () => {
      this.audioEnabled = !this.audioEnabled;
      publisher.publishAudio(this.audioEnabled);
    };

    this.togglePublisher = () => {
      this.publisherEnabled = !this.publisherEnabled;

      if (this.publisherEnabled) {
        $("#publisher").show();
      } else {
        $("#publisher").hide();
      }
    };

    this.startDisconnectTimer = () => {
      if (disconnectTimer) {
        return;
      }

      const deadline = moment().add(3, 'minutes');
      disconnectTimer = $interval(() => {
        const now = moment();
        const minutes = deadline.diff(now, 'minutes');
        const seconds = deadline.diff(now, 'seconds') - minutes * 60;

        if (minutes === 0 && seconds === 0) {
          // Timer has expired
          $interval.cancel(disconnectTimer);
          disconnectTimer = null;
          this.waitingMessage = 'The patient has not come back within 3 minutes. You may move on.';
          return;
        }

        this.waitingMessage = `<h2>${minutes}:${`${seconds}`.length === 1 ? `0${seconds}` : seconds}</h2>
            Patient has disconnected.
            Please wait 3 minutes for the patient to rejoin the session before you leave the visit.
          `;
      }, 1000);
    };
    /*
    this.updateTask = (taskStatus) => {
      VideoService
        .updateTask(this.task.id, taskStatus)
        .then(() => {
          this.initialized = false;
          this.call = null;
          this.audioEnabled = true;
          this.task.status = taskStatus;
           if ($rootScope.videoSession) {
            $rootScope.videoSession.disconnect();
          }
           publisher = null;
          $rootScope.videoSession = null;
           $rootScope.$broadcast('tokbox:task-updated', this.task);
          $rootScope.$broadcast('visit:refresh');
        })
        .catch((err) => {
          Utils.createErrorToast(err, 'Failed to update VideoService task.');
        })
        .finally(() => {
          this.fullscreen = false;
        });
    };
    */

  } // angular
  // .module('pims')
  // .component('tokbox', {
  //   templateUrl: 'app/components/tokbox/tokbox.html',
  //   controller: TokboxController,
  //   bindings: { patient: '=', visit: '=' },
  // });


  angular.module('pims').controller('TokboxController', TokboxController);
})();
